import { Controller, useForm } from 'react-hook-form';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import ClearIcon from '@mui/icons-material/Clear';
import MDInput from 'components/MDInput';

export function AdvisorNodeForm({ id, data, onUpdateData }) {
  const { formatMessage: msg } = useIntl();
  const prevDescriptionRef = useRef(data?.description || '');

  const { control, setValue, watch } = useForm({
    defaultValues: {
      description: data?.description || ''
    }
  });

  // Watch for changes in form values
  const formValues = watch();

  // Call onNodeChange only when form values actually change
  useEffect(() => {
    const descriptionChanged = formValues.description !== prevDescriptionRef.current;

    if (descriptionChanged) {
      prevDescriptionRef.current = formValues.description;

      const updatedData = {
        ...data,
        description: formValues.description
      };

      onUpdateData({
        id,
        data: updatedData
      });
    }
  }, [formValues, data, onUpdateData, id]);

  const clearField = (fieldName) => {
    setValue(fieldName, '');
  };

  return (
    <Stack spacing={1} sx={{ p: 1 }}>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.description.label' })}
            variant="filled"
            fullWidth
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={msg({ id: 'tooltip.clear' })}>
                    <IconButton onClick={() => clearField('description')}>
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        )}
      />
    </Stack>
  );
}

AdvisorNodeForm.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    description: PropTypes.string
  }),
  onUpdateData: PropTypes.func.isRequired
};
